import React from 'react';
import { makeStyles } from '@material-ui/core';
import config from '../../preorder/configs/config.json';

const useStyle = makeStyles((theme) => ({
  root: {
    position: 'relative',
    backgroundSize: 'cover',
    backgroundImage: `url(${config.RESOURCE_URI}CS/W24_bulkpurchase_LandingPage_20230616.jpg)`,
  },
  container: {
    padding: theme.spacing(0),
    margin: 'auto',
    width: '100vw',
    height: 'calc(100vw/1921*5753)',
  },
  button_askMe: {
    position: 'absolute',
    width: '53vw',
    height: '10.5vw',
    top: '92vw',
    left: '23.7vw',
  },
  button_1: {
    position: 'absolute',
    width: '16vw',
    height: '6.2vw',
    top: '211vw',
    left: '72.5vw',
  },
  button_2: {
    position: 'absolute',
    width: '53vw',
    height: '10.5vw',
    top: '263vw',
    left: '23.7vw',
  },
  button_3: {
    position: 'absolute',
    width: '25vw',
    height: '7vw',
    top: '282vw',
    left: '38vw',
  },
}));

export default () => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <a href="https://forms.gle/zpm6WvJojccRtBdy6" className={classes.button_askMe} target="_blank" rel="noopener noreferrer"> </a>
        <a href="/activity/menu" className={classes.button_1} target="_blank" rel="noopener noreferrer"> </a>
        <a href="https://forms.gle/zpm6WvJojccRtBdy6" className={classes.button_2} target="_blank" rel="noopener noreferrer"> </a>
        <a href="/" className={classes.button_3} target="_blank"> </a>
      </div>
    </div>
  );
};
